import type { LanguagePack } from '../types';

export const zhCN: LanguagePack = {
  locale: 'zh-CN',
  name: '简体中文',
  messages: {
    app: {
      report: {
        year: '年报',
        quarter: '季报',
      },
      reportTheme: {
        year: '全年经营复盘',
        quarter: '周期总结',
      },
      periodTitle: '第 {start}-{end} 周{label}',
    },
    ui: {
      机场浏览: '机场浏览',
      '共 {count} 个机场': '共 {count} 个机场',
      切换地图: '切换地图',
      切换机场列表: '切换机场列表',
      '航程 {distance} km': '航程 {distance} km',
      '距离 {distance} km': '距离 {distance} km',
      不可抵达: '不可达',
    },
  },
};
